{
  "title": "Agregar entidad relacionada",
  "relationship": "Relación",
  "relationshipTo": "Relación con {{whom}}",
  "alreadyRelatedTo": "La entidad ya está relacionada con",
  "thisClient": "este cliente",
  "pleaseReview": "Revise su información para asegurarse de que sea correcta.",
  "name": "Nombre",
  "continue": "Continuar",
  "added": "{{entityName}} ha sido agregada como entidad relacionada",
  "failed": "Error al agregar una nueva entidad relacionada.",
  "done": "Hecho"
}
